import { render } from "./rollCallToday.vue?vue&type=template&id=2112d3b4"
import script from "./rollCallToday.vue?vue&type=script&lang=js"
export * from "./rollCallToday.vue?vue&type=script&lang=js"

import exportComponent from "E:\\project\\lms-frontend-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__